import React, { FC } from "react";
import { Card, Col, Row } from "antd";
import Title from "antd/lib/typography/Title";
import { useIntl } from "react-intl";
import { QuestionCircleOutlined } from "@ant-design/icons";
import styles from "./facility-selection.module.scss";

export const FacilitySelectionHelp: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Card className={styles.helpCard}>
      <Title level={3}>
        {formatMessage({ id: "facility-selection-help.title" })}
      </Title>
      <Row style={{ marginTop: 20 }}>
        <Col lg={{ flex: "100px" }} xs={{ flex: 0 }}>
          <QuestionCircleOutlined className={styles.helpIcon} />
        </Col>
        <Col lg={{ flex: "auto" }} className={styles.helpText}>
          {formatMessage({ id: "facility-selection-help.text" })}
        </Col>
      </Row>
    </Card>
  );
};
